/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_CreateInputs */

const en_admin_posts_create = /** @type {(inputs: Admin_Posts_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Post`)
};

const zh_admin_posts_create = /** @type {(inputs: Admin_Posts_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建文章`)
};

/**
* | output |
* | --- |
* | "Create Post" |
*
* @param {Admin_Posts_CreateInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_create = /** @type {((inputs?: Admin_Posts_CreateInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_CreateInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_create(inputs)
	return zh_admin_posts_create(inputs)
});
export { admin_posts_create as "admin.posts.create" }